import Api from '../api/api.js';

import Modal from '../alerts/modal.js';

import ImportRecord from './import-record.js';


export default class ImportRecords {


	constructor(params = {})
	{
		this.params = params;
	}


	init()
	{
		$(this.params['container']).find('form').each((index, $form) => {

			(new ImportRecord({

				$element: $form,

				cached_key: this.params['cached_key']

			})).render();

		});

	}


	import($form, queue = true) 
	{
		var data = $form.serializeObject();

		data.queue = queue;

		var import_record = new ImportRecord({

			$element: $form,

			cached_key: this.params['cached_key']
		
		})

		return new Promise((resolve, reject) => {
				
			(new Api)

				.postRequest($form.attr('action'), data)

				.then((response) => {

					import_record.markAsQueued();

					import_record.render();

			       	resolve(response);

				});
		});
	}


 	showSpinner()
	{
		var spinner = 
		`<span style='margin-right:40px'>
			<img height='40px' width='40px' src='/images/loader_50px.gif'/>${this.params['spinner_msg']}
		</span>`;
		$('.loading').html(spinner);
	}


	hideSpinner()
	{
		$('.loading').html('');
	}


	getRecords()
	{
		return new Promise((resolve, reject) => {

			(new Api).getRequest(this.params['ajax_path'])

		    	.then((response) => { 	
				
		       		resolve(response);

				}, (error) => {

					reject(error);

				});

		});
	}


	removeItem(form)
	{
		$(form).remove();
	}


	onImportSingle(e)
	{
		e.preventDefault();

		var $form = $(e.currentTarget).closest('form');

		this.import($form, false).then((response) => {

			var msg = response.msg || 'Record imported';

			(new Modal).success('Success', msg, 'success')

				.then(() => {
			
				 	this.removeItem($form);

				});

		});
	}


	onImportAll(e)
	{
		e.preventDefault();

		var $clicked = $(e.currentTarget);

		$clicked.addClass('disabled');

		var queue = $clicked.data('queue') === 'true';

		var $forms = $(this.params['container']).find('form');


		this.showSpinner();

		var requests = [];

		$forms.each((index, form) => {
			console.log(index,form,queue);
			requests.push(this.import($(form), queue));
				
		});

		Promise.all(requests).then((response) => {

			this.hideSpinner();

			var msg = response.msg || (queue ? 'Requests queued' : 'Requests imported');

			(new Modal).success('Success', msg, 'success')

				.then(() => {
			
				 	this.removeItem($form);

				});

		});

	}


}